/**
 * MD5 签名工具
 * 用于生成 API 请求签名
 */
import md5 from 'js-md5'

/**
 * 生成 API 签名
 * 签名规则：将参数按 key 字母排序，拼接所有 value，再加 md5Key，最后 MD5 转大写
 *
 * 对应后端 TreeMap 排序逻辑：
 * appid -> deductModel -> provinceName -> requestId -> timestamp
 *
 * @param {Object} params - 请求参数
 * @param {string} md5Key - 签名密钥
 * @returns {string} 大写的 MD5 签名
 */
export function generateSign(params, md5Key) {
  // 按 key 字母排序（模拟 Java TreeMap）
  var keys = Object.keys(params).sort()

  // 拼接所有 value
  var values = keys.map(function(key) {
    return String(params[key])
  })

  var signStr = values.join('') + md5Key
  console.log('Sign String:', signStr)

  return md5(signStr).toUpperCase()
}

/**
 * 生成请求ID
 * @returns {string} 基于时间戳的请求ID
 */
export function generateRequestId() {
  return Math.floor(Date.now() / 1000).toString()
}
